import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { ApplicationContext } from "@context/ApplicationContext";
import ParticipatingCinemas from "@components/ParticipatingCinemas";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const ParticipatingCinemasPage = () => {
    const { whiteLabel } = useContext(ApplicationContext);
    const brand = whiteLabel?.brand_name;

    return (
        <VersionedLayout minimal>
            <Helmet>
                <title>{`${brand} | ${whiteLabel?.brand_title}`}</title>
                <meta name="keywords" content={`${brand} | ${whiteLabel?.brand_title}`} />
                <link rel="canonical" href={`${window.location.protocol}//${window.location.host}`} />
            </Helmet>
            <ParticipatingCinemas />
        </VersionedLayout>
    );
};

export default ParticipatingCinemasPage;
